module.exports = __webpack_public_path__ + "img/Vision-based guidance system.de633112.jpg";